
export enum Columns {
    ORDER = "order", STATUS = "status", HOLD = "hold", PLANNING = "planning", CARRIER = "carrier", OFFERS = "offers", CARRIER_COMMUNICATIONS = "carrierCommunications",
    NEXT_STOP = "nextStop", REF_NBR = "refNbr", ORIGIN = "origin", DEST = "dest", DISTANCE = "distance", COMMODITY = "commodity", TRAILER = "trailer", REVENUE = "revenue",
    CUSTOMER = "customer", USERS = "users", CODES = "codes"
}
